import { render, staticRenderFns } from "./AdminSingleImageUpload.vue?vue&type=template&id=c0949c5e&scoped=true"
import script from "./AdminSingleImageUpload.vue?vue&type=script&lang=js"
export * from "./AdminSingleImageUpload.vue?vue&type=script&lang=js"
import style0 from "./AdminSingleImageUpload.vue?vue&type=style&index=0&id=c0949c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0949c5e",
  null
  
)

export default component.exports